import { Component, OnInit } from '@angular/core';
import { E5coreUiWorkHistoryBaseComponent } from './e5core-ui-work-history-base';

@Component({
  selector: 'e5core-ui-work-history-bootstrap',
  templateUrl: './e5core-ui-work-history-bootstrap.component.html',
  styleUrls: ['./e5core-ui-work-history-bootstrap.component.css']
})
export class E5coreUiWorkHistoryBootstrapComponent extends E5coreUiWorkHistoryBaseComponent {

}
